<template>
    <HeaderMaridador />
    <div class="container-fluid mt-3">
    <p class="text-light text-kroon">
      1. Selecciona tu Kroon favorito
    </p>

    <!-- Carousel Slider de Quesos con efecto Carousel y autoplay -->
    <swiper
      :effect="'carousel'"
      :slidesPerView="2"
      :spaceBetween="40"
      :loop="true"
      :autoplay="!quesoSeleccionado && { delay: 3000, disableOnInteraction: true }"
      :modules="modules"
      class="selector-quesos slider-custom"
      ref="selectorQuesos"
    >
      <swiper-slide 
        v-for="queso in quesos" 
        :key="queso.id" 
        :class="{ 'active-slide': quesoSeleccionado === queso.id }"
      >
        <img 
          style="margin-bottom: 20px; margin-top: 25px;"
          :src="require(`../assets/${queso.imagen}`)" 
          @click="selectQueso(queso.id)" 
          :class="{ 
            selected: quesoSeleccionado === queso.id, 
            'centered-queso': quesoSeleccionado === queso.id 
          }" 
        />
        <p style="margin-top: 10px;" :class="{ 'queso-nombre-seleccionado': quesoSeleccionado === queso.id }">
          {{ queso.nombre }}
        </p>
      </swiper-slide>
    </swiper>

    <!-- Descripción del Queso Seleccionado -->
    <div v-if="quesoSeleccionado" class="queso-descripcion">
      <p>{{ getQuesoDescripcion(quesoSeleccionado) }}</p>
    </div>
    <p class="text-light text-kroon mt-2">
      2. Elige hasta 5 ingredientes
    </p>

    <!-- Ingredientes -->
    <div v-for="(categoria, nombreCategoria) in ingredientesDisponibles" :key="nombreCategoria">
      <!-- Se comenta el título de cada grupo de ingredientes -->
      <!-- <h6>{{ nombreCategoria }}</h6> -->
      <div class="fila-ingredientes">
        <div 
          v-for="ingrediente in categoria" 
          :key="ingrediente.id" 
          class="ingrediente-container"
        >
          <img 
            :src="require(`../assets/${ingrediente.imagen}`)" 
            @click="toggleIngrediente(ingrediente.id)" 
            :class="{ selected: ingredientesSeleccionados.includes(ingrediente.id) }" 
          />
          <!-- Tooltip animado que se muestra únicamente al seleccionar -->
          <div 
            v-if="ingredientesTooltip.includes(ingrediente.id)" 
            class="tooltip"
            :ref="'tooltip-' + ingrediente.id"
          >
            {{ ingrediente.nombre }}
          </div>
        </div>
      </div>
    </div>

    <!-- Contenedor para la sección "Agrega tu toque personal" con 5px de padding -->
    <div class="contenedor-adicional">
      <p class="text-light text-kroon mt-5">
        3. Agrega tu toque personal
      </p>

      <input 
        type="text" 
        v-model="ingredientesAdicionales" 
        placeholder="Ingredientes o adornos" 
        class="input-personalizado" 
      />

      <form @submit.prevent="calificaMiCreacion" class="form-group">
        <button 
          @click="calificaMiCreacion" 
          class="btn btn-warning" 
          :disabled="!quesoSeleccionado || cargando"
        >
          <!-- Spinner solo cuando está cargando -->
          <span 
            v-if="cargando" 
            class="spinner-border spinner-border-sm" 
            role="status" 
            aria-hidden="true"
          ></span>
          
          <!-- El icono de Sparkles solo se muestra cuando no se está cargando -->
          <SparklesIcon v-if="!cargando" class="sparkles-icon"/>

          <!-- Texto que varía según el estado -->
          <span 
            v-if="!cargando" 
            style="padding-left: 10px; font-size: 0.8em"
          >
            Crear mi tabla con IA
          </span>
          <span 
            v-if="cargando"
            style="padding-left: 10px; font-size: 0.8em"
          >
            {{ mensajeActual }}
          </span>
        </button>
        <!-- Liga a los términos y condiciones -->
        <p class="text-center mt-3">
          <a 
            @click.prevent="mostrarTerminos" 
            href="#" 
            class="terminos-link"
          >
            Términos y condiciones
          </a>
        </p>

        <!-- Modal de términos y condiciones -->
        <div v-if="mostrarModalTerminos" class="modal-backdrop">
          <div class="modal-content">
            <span 
              @click="cerrarModalTerminos" 
              class="close-button"
            >
              &times;
            </span>
            <iframe 
              src="/terminos" 
              style="width: 100%; height: 800px; border: none;"
            ></iframe>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import '@/assets/carousel/effect-carousel.min.css';
import { FreeMode, Pagination, Autoplay } from 'swiper/modules';
import CarouselEffect from '@/assets/carousel/effect-carousel.esm.js';
import { SparklesIcon } from '@heroicons/vue/outline';
import HeaderMaridador from './HeaderMaridador.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    HeaderMaridador,
    SparklesIcon,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      quesoSeleccionado: null,
      ingredientesSeleccionados: [],
      ingredientesAdicionales: '',
      cargando: false,
      intentoEnvio: false,
      mostrarModalTerminos: false,
      mostrarModalQuesos: false,
      ingredientesTooltip: [] // Controla la visualización del tooltip
    };
  },
  computed: {
    ...mapGetters(['quesos', 'ingredientesDisponibles']),
  },
  setup() {
    return {
      modules: [FreeMode, Pagination, Autoplay, CarouselEffect],
    };
  },
  methods: {
    selectQueso(id) {
      this.quesoSeleccionado = id;
      this.$nextTick(() => {
        setTimeout(() => {
          // const swiper = this.$refs.selectorQuesos.$swiper;
          const index = this.quesos.findIndex(queso => queso.id === id);
          console.log("index", index);
          console.log("quesoSeleccionado", this.quesoSeleccionado);
        });
      });
    },
    getQuesoDescripcion(id) {
      const queso = this.quesos.find(q => q.id === id);
      return queso ? queso.descripcion : '';
    },
    toggleIngrediente(id) {
      const index = this.ingredientesSeleccionados.indexOf(id);
      if (index > -1) {
        this.ingredientesSeleccionados.splice(index, 1);
      } else {
        if (this.ingredientesSeleccionados.length >= 5) {
          // Mostrar tooltip de advertencia
          this.mostrarTooltipAdvertencia();
          return; // No agregar más ingredientes
        }
        this.ingredientesSeleccionados.push(id);
        // Se activa el tooltip y se elimina después de 2 segundos
        this.ingredientesTooltip.push(id);
        this.$nextTick(() => {
          const tooltipElem = this.$refs['tooltip-' + id];
          if (tooltipElem) {
            const el = Array.isArray(tooltipElem) ? tooltipElem[0] : tooltipElem;
            const rect = el.getBoundingClientRect();
            let offset = 0;
            if (rect.left < 5) {
              offset = 5 - rect.left;
            } else if (rect.right > window.innerWidth - 5) {
              offset = (window.innerWidth - 5) - rect.right;
            }
            if (offset !== 0) {
              el.style.transform = `translateX(calc(-50% + ${offset}px))`;
            }
          }
        });
        setTimeout(() => {
          const tooltipIndex = this.ingredientesTooltip.indexOf(id);
          if (tooltipIndex !== -1) {
            this.ingredientesTooltip.splice(tooltipIndex, 1);
          }
        }, 2000);
      }
    },
    mostrarTooltipAdvertencia() {
      this.ingredientesTooltip.push('advertencia'); // Usar un ID especial para el tooltip de advertencia
      setTimeout(() => {
        const tooltipIndex = this.ingredientesTooltip.indexOf('advertencia');
        if (tooltipIndex !== -1) {
          this.ingredientesTooltip.splice(tooltipIndex, 1);
        }
      }, 2000);
    },
    calificaMiCreacion() {
      this.intentoEnvio = true;

      if (!this.quesoSeleccionado) {
        return;
      }

      const datos = {
        quesoSeleccionado: this.quesoSeleccionado,
        ingredientes: [
          ...this.ingredientesSeleccionados.filter(id => this.ingredientesDisponibles.crujiente.some(ing => ing.id === id)),
          ...this.ingredientesSeleccionados.filter(id => this.ingredientesDisponibles.panesGalletas.some(ing => ing.id === id)),
          ...this.ingredientesSeleccionados.filter(id => this.ingredientesDisponibles.dulce.some(ing => ing.id === id)),
          ...this.ingredientesSeleccionados.filter(id => this.ingredientesDisponibles.vegetal.some(ing => ing.id === id)),
          ...this.ingredientesSeleccionados.filter(id => this.ingredientesDisponibles.charcuteria.some(ing => ing.id === id)),
          ...this.ingredientesSeleccionados.filter(id => this.ingredientesDisponibles.bebida.some(ing => ing.id === id))
        ],
        ingredientes_adicionales: this.ingredientesAdicionales
      };

      console.log('Datos enviados:', datos);

      this.cargando = true;

      fetch(`${process.env.VUE_APP_BACKEND_URL}/califica`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos)
      })
        .then(response => response.json())
        .then(data => {
          this.$store.dispatch('actualizarResultado', data);
          this.$store.dispatch('actualizarIngredientes', datos);
          this.$router.push({ name: 'resultado' });
        })
        .catch(error => {
          console.error('Error:', error);
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    mostrarTerminos() {
      this.mostrarModalTerminos = true;
    },
    cerrarModalTerminos() {
      this.mostrarModalTerminos = false;
    },
    abrirSelectorQuesos() {
      this.mostrarModalQuesos = true;
    },
    cerrarSelectorQuesos() {
      this.mostrarModalQuesos = false;
    }
  }
};
</script>

<style scoped>
.selector-quesos {
  width: 100%;
  height: 260px;
}

/* Si deseas ajustar el slider con el efecto Carousel, por ejemplo: */
.slider-custom {
  /* Aquí puedes agregar propiedades o sobreescribir estilos del efecto si es necesario */
}

.selected {
  border: 3px solid #ffffff;
  background-color: #000000;
}
.centered-queso {
  transform: scale(1.2);
  transition: transform 0.3s;
}
.fila-ingredientes {
  display: flex;
  justify-content: space-around;
}
body {
  /* background-color: black; */
}
.queso-descripcion {
  width: 100%;
  font-size: 1.1em;
  background-color: rgba(0, 0, 0, 0);
  padding: 10px;
  margin-top: 10px;
}

.sparkles-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.sparkles-icon-small {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}

.input-personalizado {
  width: 100%;
  background-color: black !important;
  border: 1px solid grey;
  text-align: center;
  color: white;
}

/* Contenedor para cada ingrediente para posicionar el tooltip */
.ingrediente-container {
  position: relative;
  display: inline-block;
  padding: 3px;
}

/* Estilos para las imágenes de ingredientes:
   Inicialmente: padding 10px, opacidad 80%, borde #d2b48c y margen entre ellas.
   Cuando están seleccionadas: padding se reduce a 1px y opacidad 100%.
*/
.ingrediente-container img {
  padding: 4px;
  opacity: 1;
  transition: all 0.3s ease;
  border-radius: 4px;
  border: none;
  margin: 0px;
}

.ingrediente-container img.selected {
  padding: 0px;
  opacity: 1;
  border: 2px solid #ffffff;
  background-color: #000000;
  margin: 0px;   
}

/* Estilos para el tooltip animado con tamaño de fuente incrementado */
.tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 1.2em;
  white-space: nowrap;
  pointer-events: none;
  animation: floatTooltip 2s forwards;
  z-index: 10;
  /* Evita que el tooltip se desborde en el viewport */
  max-width: calc(100vw - 10px);
}

@keyframes floatTooltip {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(0);
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
}

/* La clase 'active-slide' será aplicada al contenedor del slide seleccionado */
.active-slide {
  position: relative;
  z-index: 999;
}

/* Si usas Bootstrap y necesitas asegurarte de que no haya padding horizontal */
.container-fluid {
  padding-left: 0;
  padding-right: 0;
}

/* Nueva regla: nombre del queso seleccionado en blanco y bold */
.queso-nombre-seleccionado {
  color: white;
  font-weight: bold;
}

/* Contenedor que aporta 5px de padding en cada lado */
.contenedor-adicional {
  padding: 10px;
}
</style>
